import React, { Fragment, useEffect, useRef, useState, useCallback } from 'react'
import { Link } from "react-router-dom"
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import DefaultAvatar from "../images/avatar.png"


dayjs.extend(relativeTime);



const MessageAlert = ({ alertVal }) => {




    const [visible, setVisible] = useState(false)
    const timerRef = useRef(null)


    const clearTimer = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current)
        }
    }, [])

    const startTimer = useCallback(() => {

        timerRef.current = setTimeout(() => {
            setVisible(false)



        }, 5000)

    }, [])

    useEffect(() => {


        console.log(alertVal)
        if (alertVal?.conversation_id) {
            setVisible(true)
            startTimer()

        }

        return () => clearTimer()

    }, [alertVal, startTimer, clearTimer])


    const handleClose = () => {
        clearTimer()
        setVisible(false)


    }





    return (
        <Fragment>

            <div
                onMouseEnter={clearTimer}
                onMouseLeave={startTimer}
                className={`fixed bottom-3 left-3 right-3 z-[999999] bg-white p-4 shadow-1 rounded-2xl transition-all duration-500 lg:left-auto lg:right-[1vmax] lg:bottom-[1vmax] lg:w-[26vmax] lg:p-[1vmax] lg:rounded-[1.5vmax]
                ${visible ? "translate-x-0 opacity-100" : "translate-x-[120%] opacity-0"}
                `}
            >

                <div className="flex justify-between relative text-[2.5vmax] lg:text-[0.9vmax]">

                    <button
                        className="absolute top-0 right-0"
                        onClick={handleClose}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>

                    <div className="w-[15%] relative">

                        <div className="w-full aspect-[1/1] rounded-full overflow-hidden bg-gray-200 shadow-1">
                            <img
                                src={alertVal?.avatar_url || DefaultAvatar}
                                alt=""
                                className='w-full object-cover'
                            />
                        </div>

                        <div className={`absolute top-[-1.5vmax] right-[-1.5vmax] lg:top-[-0.5vmax] lg:right-[-0.5vmax] w-[3vmax] h-[3vmax] lg:w-[1.3vmax] lg:h-[1.3vmax]  rounded-full flex-center text-[1.5vmax] lg:text-[0.7vmax] bg-red-400`}>
                            <i className="fa-solid fa-bell text-white"></i>
                        </div>

                    </div>

                    <div className="w-[80%] pr-[2vmax]">

                        <span className="text-[1.5vmax] lg:text-[0.9vmax] font-3 text-gray-500">
                            <strong className="text-blue-600 text-[1.1vmax]">{alertVal?.message?.sender_name}</strong>
                            <br />
                            {alertVal?.message?.message ?

                                alertVal?.message?.message?.length > 70 ? alertVal?.message?.message?.substring(0, 100) + "..." : alertVal?.message?.message
                            :
                            <i>A New Message Received</i>
                            }


                        </span>

                        <div className="flex justify-end mt-[0.5vmax]">

                            <Link
                                to={`/messenger?conversation_id=${alertVal?.conversation_id}`}
                                onClick={() => {
                                    handleClose();
                                }}
                                className="text-[1.5vmax] lg:text-[0.9vmax] font-[600] text-blue-500"

                            >
                                View
                            </Link>

                        </div>

                    </div>

                </div>

            </div>

        </Fragment>
    )
}

export default MessageAlert
